// validators.ts
export const required = <T>(value: T[keyof T]): string | null =>
    value ? null : 'error.required';
  
  export const validateIBAN = (value: string): string | null => {
    const normalizedIban = value?.toUpperCase().replace(/\s+/g, '');
    const ibanRegex = /^[A-Z]{2}[0-9A-Z]{13,32}$/;
    return !normalizedIban || !ibanRegex.test(normalizedIban) ? 'error.iban' : null;
  };
  
  export const validateOIB = (value: string): string | null => {
    return /^\d{11}$/.test(value) ? null : 'error.oib';
  };
  
  export const isValidDecimal = (value: string): string | null => {
    return /^\d+\.\d{2}$/.test(value) ? null : 'error.decimal';
  };
  